import React from "react";
import AdminHeader from "./AdminHeader";
import "./AdminLayout.css";

const AdminLayout = ({ children }) => {
  return (
    <div className="admin-layout">
      <AdminHeader />
      <div className="admin-content">
        {children}
      </div>
      <footer className="admin-footer">
        <p>Developed by <span className="footer-brand">VRND Business Solution</span></p>
      </footer>
    </div>
  );
};

export default AdminLayout; 